'use strict';

angular.module('myConsultApp')
	  .directive('header', function ($cookieStore, $location, $routeParams, $rootScope) {
	    return {
	      templateUrl: 'templates/header.html',
	      restrict: 'A',
	     link: function(scope, elem, attr){



			angular.element(document).ready(function () {

				$(document).on("click", function(event){
					var $navstrigger1 =  $('.navs-dropdown');
					var $orgstrigger2 =  $('.orgs-dropdown');
					if($navstrigger1 !== event.target && !$navstrigger1.has(event.target).length && $orgstrigger2 !== event.target && !$orgstrigger2.has(event.target).length){
						$('.orgs-dropdown li.submenu ul').slideUp(500);
						$('.navs-dropdown ul.submenu').slideUp(500);
						$('.navs-dropdown .hamburgerIcon').removeClass('iconActive');
						$('.orgs-dropdown li.submenu').removeClass('iconActive');
					}
				});


        $('.navs-dropdown').click(function(e) {
	        $(this).find('.hamburgerIcon').toggleClass('iconActive');
          if ($(e.target).is('.childtoggle')) {
            $(e.target).find('.innermenu').slideToggle(500);
          } else {
            $(this).find('.submenu').slideToggle(500);
          }
        });



        $('.orgs-dropdown').on('click', 'li.submenu a:first-child', function() {
          var element = $(this).parent();
          $('.orgs-dropdown li.submenu').not(element).removeClass('iconActive');
          $('.orgs-dropdown li.submenu').not(element).find('ul:first-child').stop().slideUp(function(){
            $(this).parent().removeClass('activeLite').removeClass('active');
          });

          element.find('ul:first-child').stop().slideDown(function(){
            $(this).parent().toggleClass('active');
            $(this).parent().toggleClass('iconActive');
          });
        });

      });

			/*
			angular.element(document).mouseup(function (e) {
				// Hide the mobile menu if user clicks outside it
				//TODO: This doesn't seem to work in Safari on iPad, which is ok since it's an optional feature
				var container = $('nav');
				if ($(window).width() <= 1024) {
						//Modified by JJ because this was bugging the interface.
						if (!container.is(e.target) && container.has(e.target).length === 0 && container.hasClass('opened')){
							closeMenu();
						}
				}

			});



			angular.element(window).resize(function (e) {

				//Modified by JJ because this was bugging the interface.
				//Reset the mobile menu appropriately when resizing window- mostly for testing

				//change 1024 to 1000
				if ($(window).width() > 1000) {
					openMenu();
				}else{
					closeMenu();
				}

			});
			*/

			/////////END CALLS FROM THE UI KIT JS////////////

	    }
    };
})
.directive('lastPetOwnerRepeat', function() {
        return function(scope, element, attrs) {

			element.click(function(){
				var element2 = $(this).parent();

				$('nav ul li.submenu, .orgs-dropdown li.submenu').not(element2).removeClass('iconActive');

				$('nav ul li.submenu, .orgs-dropdown li.submenu').not(element2).find('ul').stop().slideUp(1000,function(){
					$(this).parent().removeClass('activeLite').removeClass('active');
				});

				$(this).parent().toggleClass('iconActive');
				element2.find('ul').stop().slideToggle(1000,function(){
					$(this).parent().toggleClass('active');
				});
			});
        };
    })
.directive('lastOrgRepeat', function() {
        return function(scope, element, attrs) {
        };
    });
